import React, { FC, useMemo, useState, useEffect } from 'react'
import './index.scss'

// interface
interface IProps {
  data: any[];
  value: any;
  onChange: (val: any) => void;
}

const OrderTabs: FC<IProps> = (props: IProps) => {
  const { value, data, onChange } = props
  const children = useMemo(() => {
    const findData = data.find((item) => item.keys.includes(value) && item.children && item.children.length)
    return findData ? findData.children : []
  }, [value])
  return (
    <div className='order-tabs-bar-container'>
      <div className='order-tabs-bar-one-wrapper'>
        {
          data.map((item: any) => {
            const children = item.children || []
            return (
              <div
                key={item.value}
                className={`tabs-bar-item ${item.keys.includes(value) || item.value === value ? 'checked' : ''}`}
                onClick={() => onChange(item.keys[0] || item.value)}
              >
                {item.label}
              </div>
            )
          })
        }
      </div>
      {
        !!children.length && (
          <div className='order-tabs-bar-two-wrapper'>
            {
              children.map((item: any) => (
                <div
                  key={item.value}
                  className={`tabs-bar-item ${item.value === value ? 'checked' : ''}`}
                  onClick={() => onChange(item.value)}
                >
                  {item.label}
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  )
}

export default OrderTabs
